var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _g, _g2, _g3, _g4, _g5, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDeepCleaning = function SvgDeepCleaning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 94a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm56 0a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm-48 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95z",
    fill: "#332C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26H24v14h72V26z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24H28v18h64V24z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22H32v76h56V22z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22H40v68h40V22z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 63.625v.024c1.784.943 3 2.817 3 4.976A6.375 6.375 0 0176.625 75H67a5.995 5.995 0 01-5.034-2.734A3 3 0 1160 67h.188c.383 0 .749.077 1.082.216A6.003 6.003 0 0167 63h1.083A6.002 6.002 0 0174 58h.375A5.625 5.625 0 0180 63.625zm-27 6.25V70a2 2 0 11-2-2h.125C52.16 68 53 68.84 53 69.875zM61 60v-.125C61 58.84 60.16 58 59.125 58H59a2 2 0 102 2z",
    fill: "#FFD400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63.649l-.467.884a1 1 0 01-.533-.884h1zm0-.024h1-1zm-18.034 8.641l-.656-.755a1 1 0 011.494.21l-.838.545zm-.696-5.05l.955.297a1 1 0 01-1.34.626l.385-.923zM68.083 63l.986.166a1 1 0 01-.986.834v-1zM59 62v1-1zm20 1.649v-.024h2v.024h-2zm3 4.976a4.624 4.624 0 00-2.467-4.092l.934-1.768A6.624 6.624 0 0184 68.625h-2zM76.625 74A5.375 5.375 0 0082 68.625h2A7.375 7.375 0 0176.625 76v-2zM67 74h9.625v2H67v-2zm-4.196-2.279A4.995 4.995 0 0067 74v2a6.995 6.995 0 01-5.872-3.189l1.676-1.09zM60 72c.502 0 .959-.184 1.31-.489l1.312 1.51c-.702.61-1.62.979-2.622.979v-2zm-2-2a2 2 0 002 2v2a4 4 0 01-4-4h2zm2-2a2 2 0 00-2 2h-2a4 4 0 014-4v2zm.188 0H60v-2h.188v2zm.697.139a1.804 1.804 0 00-.697-.139v-2c.517 0 1.014.104 1.467.293l-.77 1.846zM67 64a5.003 5.003 0 00-4.775 3.513l-1.91-.594A7.003 7.003 0 0167 62v2zm1.083 0H67v-2h1.083v2zM74 59a5.002 5.002 0 00-4.93 4.166l-1.973-.331A7.002 7.002 0 0174 57v2zm.375 0H74v-2h.375v2zM79 63.625A4.625 4.625 0 0074.375 59v-2A6.625 6.625 0 0181 63.625h-2zM52 70v-.125h2V70h-2zm-1 1a1 1 0 001-1h2a3 3 0 01-3 3v-2zm-1-1a1 1 0 001 1v2a3 3 0 01-3-3h2zm1-1a1 1 0 00-1 1h-2a3 3 0 013-3v2zm.125 0H51v-2h.125v2zm.875.875a.875.875 0 00-.875-.875v-2A2.875 2.875 0 0154 69.875h-2zm10-10V60h-2v-.125h2zM59.125 57A2.875 2.875 0 0162 59.875h-2a.875.875 0 00-.875-.875v-2zM59 57h.125v2H59v-2zm-3 3a3 3 0 013-3v2a1 1 0 00-1 1h-2zm3 3a3 3 0 01-3-3h2a1 1 0 001 1v2zm3-3a3 3 0 01-3 3v-2a1 1 0 001-1h2z",
    fill: "#332C4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 73.5,
    width: 17,
    height: 25,
    rx: 6,
    transform: "rotate(-30 69 73.5)",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepCleaning_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.495 85.266l.031.055a1 1 0 10.366-1.366l-.054.03a.938.938 0 00-.343 1.281z",
    fill: "#332C4A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepCleaning_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.469 84.812l.03.054a1 1 0 10.367-1.366l-.054.031a.938.938 0 00-.343 1.28z",
    fill: "#332C4A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepCleaning_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.469 78.812l.03.054a1 1 0 10.367-1.366l-.054.031a.938.938 0 00-.343 1.28z",
    fill: "#332C4A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepCleaning_svg__filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.469 72.812l.03.054a1 1 0 10.367-1.366l-.054.031a.938.938 0 00-.343 1.28z",
    fill: "#332C4A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepCleaning_svg__filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.469 78.812l.03.054a1 1 0 10.367-1.366l-.054.031a.938.938 0 00-.343 1.28z",
    fill: "#332C4A"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29l2.43 6.57L76 38l-6.57 2.43L67 47l-2.43-6.57L58 38l6.57-2.43L67 29zM51 44l1.89 5.11L58 51l-5.11 1.89L51 58l-1.89-5.11L44 51l5.11-1.89L51 44z",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "deepCleaning_svg__filter0_d",
    x: 84.369,
    y: 83.821,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "deepCleaning_svg__filter1_d",
    x: 77.343,
    y: 83.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "deepCleaning_svg__filter2_d",
    x: 73.343,
    y: 77.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "deepCleaning_svg__filter3_d",
    x: 76.343,
    y: 71.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "deepCleaning_svg__filter4_d",
    x: 80.343,
    y: 77.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

export default SvgDeepCleaning;